import { useTranslation } from "react-i18next";
import { useInboxMessageTime } from "../../../../../../../logic/hooks/useInboxMessageTime";
import "./InboxMessageAge.scss";

interface InboxMessageAgeProps {
    createdAt: string;
}

export function InboxMessageAge({ createdAt }: InboxMessageAgeProps) {
    const { i18n } = useTranslation();
    const { ageLabel } = useInboxMessageTime(
        createdAt,
        null,
        i18n.resolvedLanguage ?? "en",
    );

    return (
        <time className="inbox-message-age" dateTime={createdAt}>
            {ageLabel}
        </time>
    );
}
